import { Checkbox } from "@dune/ui";
import { getCheckboxesToHide } from "@dune/utils";
import { actionTypeCheckboxes } from "@dune/vars";
import { useFormContext, useWatch } from "react-hook-form";
import { defaultActionValues } from "./useConstructionSiteDetailsForm";

type ActionTypesDetailsContainerProps = {
	isComplementary?: boolean;
};

const ActionTypesDetailsContainer = ({
	isComplementary = false,
}: ActionTypesDetailsContainerProps) => {
	const {
		control,
		setValue,
		formState: { errors },
	} = useFormContext();

	const actionsValue = useWatch({
		control,
		name: isComplementary ? "actions.complementaryActions" : "actions",
	});
	const { types, ...actionsValueWithoutTypes } = actionsValue;
	const { typeCheckboxesToHide } = getCheckboxesToHide(actionsValue.types);
	const error = isComplementary
		? errors.actions && "complementaryActions" in errors.actions
			? errors.actions.complementaryActions?.types
			: undefined
		: errors.actions?.types;

	return (
		<div className="flex flex-col gap-4">
			{!isComplementary && "Elle consiste en"}
			{error?.message && (
				<span className="text-red-500 text-sm">
					{error?.message?.toString()}
				</span>
			)}
			<div className="grid grid-cols-3 gap-2">
				{actionTypeCheckboxes.map((typeCheckbox) =>
					typeCheckboxesToHide.includes(typeCheckbox.value) ? (
						<div key={typeCheckbox.value} />
					) : (
						<Checkbox
							id={
								isComplementary
									? `complementary-${typeCheckbox.label}`
									: typeCheckbox.label
							}
							key={typeCheckbox.value}
							label={typeCheckbox.label}
							checked={actionsValue?.types.includes(typeCheckbox.value)}
							onCheckedChange={(checked) => {
								if (actionsValue.types.length === 1 && !checked) {
									setValue(
										isComplementary
											? "actions.complementaryActions"
											: "actions",
										defaultActionValues,
									);
								} else {
									setValue(
										isComplementary
											? "actions.complementaryActions"
											: "actions",
										{
											types: checked
												? [...actionsValue.types, typeCheckbox.value]
												: actionsValue.types.filter(
														(type: string) => type !== typeCheckbox.value,
													),
											...(checked || actionsValue.types.length > 1
												? { ...actionsValueWithoutTypes }
												: {}),
										},
									);
								}
								if (!isComplementary) {
									setValue("totalAmountTTC", undefined);
									setValue("totalAmountHT", undefined);
								}
							}}
							className="border-gray-300 disabled:bg-gray-100"
						/>
					),
				)}
			</div>
		</div>
	);
};
export default ActionTypesDetailsContainer;
